import { combineReducers } from 'redux';

import help from './helpReducer';
import helpFeedback from './helpFeedbackReducer';
import status from './statusReducer';
import results from './resultsReducer';
import rating from './ratingReducer';
import history from './historyReducer';
import receipt from './receiptReducer';
import punchCards from './punchCardsReducer';

export default combineReducers({
  help,
  helpFeedback,
  status,
  results,
  rating,
  history,
  receipt,
  punchCards,
});
